import Head from "next/head";
import { fromUrl, toUrl } from "common/src/Aperture.bs";
import { make as AugmentPage } from "../../src/items/AugmentPage.bs";
import { make as AugmentsPage } from "../../src/items/AugmentsPage.bs";
import { getApertures } from "../../utils/static-paths";
import { renderFull, toApiUrl as patchToUrl } from "common/src/Patch.bs";
import { augments } from "common/src/data/Data18.bs";

export default function Items({
  augmentId,
  augmentData,
  aperture,
  augsData,
  fullCount,
  globalCount,
}) {
  if (augmentId != null) {
    return (
      <>
        <Head>
          <title>{`TFT Augments Stats - Best Augments for Set 18 Patch ${renderFull(
            aperture.patch,
          )}`}</title>
        </Head>
        <AugmentPage
          augmentData={augmentData}
          fullCount={fullCount}
          globalCount={globalCount}
        />
      </>
    );
  } else {
    return (
      <>
        <Head>
          <title>{`TFT Augments Stats - Best Augments for Set 18 Patch ${renderFull(
            aperture.patch,
          )}`}</title>
        </Head>
        <AugmentsPage augsData={augsData} globalCount={globalCount} />
      </>
    );
  }
}

export async function getStaticPaths() {
  const params = getApertures();
  return {
    paths: [],
    // paths: params.map((params) => ({
    //   params: params,
    // })),
    fallback: "blocking",
  };
}

export async function getStaticProps({ params, locale }) {
  if (params.slug?.[0] && augments[params.slug[0]] != null) {
    const id = params.slug[0];
    const aperture = fromUrl(params.slug.slice(1));

    const statsResp = await fetch(
      `https://d3.tft.tools/stats2/general/${aperture.queue}/${patchToUrl(
        aperture.patch,
      )}/${aperture.rankGroup}`,
    );
    const statsData = await statsResp.json();

    const augmentResp = await fetch(
      `https://d3.tft.tools/stats2/augment/${aperture.queue}/${id}/${patchToUrl(
        aperture.patch,
      )}/${aperture.rankGroup}`,
    );
    // console.log(
    //   `https://d3.tft.tools/stats/augment/${id}/${patchToUrl(aperture.patch)}/${
    //     aperture.rankGroup
    //   }`
    // );
    const augmentData = await augmentResp.json();

    const fullResp = await fetch(
      `https://d3.tft.tools/stats2/augments/${aperture.queue}/${patchToUrl(
        aperture.patch,
      )}/${aperture.rankGroup}`,
    );
    const fullData = await fullResp.json();

    const globalCount = statsData.totalEntries;
    const fullCount = fullData.singles.find((s) => s.id == id).base.count;

    return {
      props: {
        augmentId: id,
        aperture,
        augmentData,
        fullCount,
        globalCount,
      },
      revalidate: 3600,
    };
  } else {
    const aperture = fromUrl(params.slug || []);
    const augsResp = await fetch(
      `https://d3.tft.tools/stats2/augments/${aperture.queue}/${patchToUrl(
        aperture.patch,
      )}/${aperture.rankGroup}`,
    );
    const augsData = await augsResp.json();

    const statsResp = await fetch(
      `https://d3.tft.tools/stats2/general/${aperture.queue}/${patchToUrl(
        aperture.patch,
      )}/${aperture.rankGroup}`,
    );
    const statsData = await statsResp.json();
    const globalCount = statsData.totalEntries;

    return {
      props: {
        aperture,
        augsData,
        globalCount,
      },
      revalidate: 3600,
    };
  }
}
